export default "__VITE_ASSET__Bnzj0YyP__"